"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transfromUpdateMarketParams = exports.transformFeeTierParams = exports.MarketModule = void 0;
const tx_1 = require("../codec/Switcheo/carbon/market/tx");
const util_1 = require("../util");
const base_1 = __importDefault(require("./base"));
class MarketModule extends base_1.default {
    getFeeTiers(marketType) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const fetchDataResponse = yield this.sdkProvider.query.market.FeeTiers({
                marketType: marketType,
                marketId: '',
                userAddress: '',
            });
            return (_a = fetchDataResponse === null || fetchDataResponse === void 0 ? void 0 : fetchDataResponse.feeTiers) !== null && _a !== void 0 ? _a : [];
        });
    }
    getTradingFees(marketId, userAddress) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const fetchDataResponse = yield this.sdkProvider.query.market.TradingFees({
                marketId: marketId,
                userAddress: userAddress,
            });
            return (_a = fetchDataResponse === null || fetchDataResponse === void 0 ? void 0 : fetchDataResponse.fees) !== null && _a !== void 0 ? _a : { takerFee: '', makerFee: '' };
        });
    }
    update(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgUpdateMarket.fromPartial({
                updater: wallet.bech32Address,
                marketParams: transfromUpdateMarketParams(params),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateMarket,
                value,
            }, opts);
        });
    }
    createMarket(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgCreateMarket.fromPartial({
                creator: params.creator,
                marketType: params.marketType,
                base: params.base,
                quote: params.quote,
                currentBasePriceUsd: params.currentBasePriceUsd,
                currentQuotePriceUsd: params.currentQuotePriceUsd,
                indexOracleId: params.indexOracleId,
                expiryTime: params.expiryTime,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgCreateMarket,
                value,
            }, opts);
        });
    }
    disableSpotMarket(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgDisableSpotMarket.fromPartial({
                creator: params.creator,
                marketId: params.marketId,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgDisableSpotMarket,
                value,
            }, opts);
        });
    }
    addFeeTier(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgAddFeeTier.fromPartial({
                creator: params.creator,
                feeCategory: params.feeCategory,
                feeTier: transformFeeTierParams(params.feeTier),
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgAddFeeTier,
                value,
            }, opts);
        });
    }
    updateFeeTier(params, opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const feeTier = transformFeeTierParams(params.feeTier);
            const value = tx_1.MsgUpdateFeeTier.fromPartial({
                updater: params.updater,
                feeCategory: params.feeCategory,
                requiredStake: feeTier.requiredStake,
                takerFee: (_a = feeTier.tradingFees) === null || _a === void 0 ? void 0 : _a.takerFee,
                makerFee: (_b = feeTier.tradingFees) === null || _b === void 0 ? void 0 : _b.makerFee,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgUpdateFeeTier,
                value,
            }, opts);
        });
    }
    removeFeeTier(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgRemoveFeeTier.fromPartial({
                remover: params.remover,
                feeCategory: params.feeCategory,
                requiredStake: params.requiredStake,
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgRemoveFeeTier,
                value,
            }, opts);
        });
    }
    setStakeEquivalence(params, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const wallet = this.getWallet();
            const value = tx_1.MsgSetStakeEquivalence.fromPartial({
                setter: params.setter,
                stakeEquivalence: {
                    ratio: params.stakeEquivalence.ratio.shiftedBy(18).toString(10),
                    denom: params.stakeEquivalence.denom,
                },
            });
            return yield wallet.sendTx({
                typeUrl: util_1.CarbonTx.Types.MsgSetStakeEquivalence,
                value,
            }, opts);
        });
    }
}
exports.MarketModule = MarketModule;
function transformFeeTierParams(msg) {
    return {
        requiredStake: msg.requiredStake,
        tradingFees: {
            makerFee: msg.makerFee.shiftedBy(18).toString(10),
            takerFee: msg.takerFee.shiftedBy(18).toString(10),
        },
    };
}
exports.transformFeeTierParams = transformFeeTierParams;
function transfromUpdateMarketParams(msg) {
    return {
        name: msg.name,
        displayName: msg.displayName,
        description: msg.description,
        lotSize: msg.lotSize.toString(10),
        tickSize: msg.tickSize.shiftedBy(18).toString(10),
        minQuantity: msg.minQuantity.toString(10),
        makerFee: msg.makerFee.shiftedBy(18).toString(10),
        takerFee: msg.takerFee.shiftedBy(18).toString(10),
        riskStepSize: msg.riskStepSize.toString(10),
        initialMarginBase: msg.initialMarginBase.shiftedBy(18).toString(10),
        initialMarginStep: msg.initialMarginStep.shiftedBy(18).toString(10),
        maintenanceMarginRatio: msg.maintenanceMarginRatio.shiftedBy(18).toString(10),
        maxLiquidationOrderTicket: msg.maxLiquidationOrderTicket.toString(10),
        maxLiquidationOrderDuration: msg.maxLiquidationOrderDuration,
        impactSize: msg.impactSize.toString(10),
        markPriceBand: msg.markPriceBand,
        lastPriceProtectedBand: msg.lastPriceProtectedBand,
        isActive: msg.isActive,
        tradingBandwidth: msg.tradingBandwidth,
    };
}
exports.transfromUpdateMarketParams = transfromUpdateMarketParams;
